module.exports = __webpack_public_path__ + "static/media/callgage-about-header.f54c7bb7.jpg";